module.exports = __webpack_public_path__ + "static/logo-4e2be2a3096681e61b9c927dc9af93e3.svg";